export const GET_INDUSTRIES = 'GET_INDUSTRIES'
